import { createTemplate } from "./template/base";
import { buildSummary } from './components/buildsummary';
import { validation } from '../../Foundation/validation/configurator'
import { dialogHelper } from "../../Foundation";

/**
 * ITE configurator markup for HCP Connect
 */

export class ITEConfiguratorHCP extends HTMLElement {
    #refs;
    constructor() {
        super();
        this.#refs = {
            el: this
        }
        this.debug = {
            debugOn: false,
            consoleParent: 'background: #aaa; color: #fff; padding: 4px 10px;margin-top:20px;',
            consoleInfo: 'background: #ECBE13; color: #fff; padding: 4px 10px;',
            consoleParentTrue: 'background: #00C176; color: #fff; padding: 4px 10px;border-left:20px solid white;',
            consoleChildTrue: 'background: #00C176; color: #fff; padding: 4px 10px;border-left:40px solid white;',
            consoleClick: 'background: #3A89C9; color: #fff; padding: 4px 10px;border-left:40px solid white;',
        };
        this.#setCartDialogCloseListeners()
        this.#removeMarginFromHiddenSections();
        this.#removeEmptyConfigureForm();
        this.#prepareProductDescription()
    }

    #prepareProductDescription() {
        this.#removeDotIfEmptyModelText();
        this.#removeDashFromProductNumber();
        this.#removeProductBrandIfEmpty();
        this.#removeProductTextBrandIfEmpty();
        this.#removeEmptyConfigureFormInfo();
        this.#removeEmptyConfigureFormInfoParagraphs();
    }

    #removeProductBrandIfEmpty() {
        const productBrand = document.querySelector('.product_brand');
        if (productBrand.innerText.trim() === '') {
            productBrand.style.display = "none";
        }
    }

    #removeProductTextBrandIfEmpty() {
        document.querySelectorAll('.product_text__brand').forEach(model => {
            if (model.innerText.trim() === '') {
                model.classList.add('product_text__brand--hidden');
            }
        })
    }

    #removeDashFromProductNumber() {
        const productNumber = document.querySelector('.product_number');
        const trimmedNumber = productNumber.innerText.trim();
        if (trimmedNumber.slice(-1) === "-") {
            const editedNumber = trimmedNumber.substring(0, trimmedNumber.length - 1)
            productNumber.innerText = editedNumber;
        }
    }

    #removeDotIfEmptyModelText() {
        document.querySelectorAll('span.product-item__modelText').forEach(model => {
            if (model.innerText.trim() === '') {
                model.previousElementSibling.classList.add('product-item__familyCode--hidden');
                model.classList.add('product-item__modelText--hidden');
            }
        })
    }

    #removeEmptyConfigureFormInfo() {
        const configureFormInfo = document.querySelector('.configureFormInfo');

        if (configureFormInfo && configureFormInfo.children && configureFormInfo.children.length < 2) {
            configureFormInfo.style.display = "none"
        }
    }

    #removeEmptyConfigureFormInfoParagraphs() {
        const paragraphs = document.querySelectorAll('.configureFormInfo p');

        Array.from(paragraphs).forEach(paragraph => {
            const isParagraphEmpty = !paragraph.textContent.trim()?.length;

            if(isParagraphEmpty) {
                paragraph.style.display = "none";
            }
        })
    }

    #removeMarginFromHiddenSections() {
        setTimeout(() => {
            Array.from(
                document.querySelectorAll(".clearfix.configurator__section.visible")
            ).forEach((section) => {
            if (section.getBoundingClientRect().height === 0) {
                section.style.margin = 0;
            }
            });
        }, 5000)
    }

    #removeEmptyConfigureForm() {
        const configureForm = Array.from(document.querySelectorAll('.configurator__section .configureForm'));

        configureForm.forEach((section) => {
            if (
                section &&
                section.children &&
                section.children.length < 2 &&
                section.innerText.trim() === ""
            ) {
                section.style.display = "none";
            }
        });
    }

    #setCartDialogCloseListeners() {
      // Prevent dialog modal to close on esc key
      const dialog = document.querySelector(".configurator_modal");
      const submitButtons = dialog
        ? [...dialog.querySelectorAll('input[type="submit"]')]
        : null;
      if (dialog) {
        dialogHelper.preventDialogModalCloseOnEscape(dialog);
        dialogHelper.closeOnSubmit(dialog, submitButtons);
      }
    }

    #showConfigurator() {
        if (this.debug.debugOn) {
            console.log('%c showConfigurator Called', this.debug.consoleParentTrue);
        }
        this.classList.add('show');
    }

    #getQuestions() {

        if (this.debug.debugOn) {
            console.log('%c getQuestions Called', this.debug.consoleParentTrue);
        }

        // Get all areas
        let configurators = document.querySelectorAll('.configurator');
        // On pageReload HTML changes for some e.g Left side
        let configuratorSections = document.querySelectorAll('.configurator_contents > [id*="Section"]');

        // Get Product Details
        let productDetails = document.querySelector('.product_details') ? document.querySelector('.product_details') : null;
        // Get CTA Controller
        let ctaController = document.querySelector('.cta_controller') ? document.querySelector('.cta_controller') : null;
        // Get Page Controls - Temporary as this button should be replaced
        let pageControls = document.querySelector('.page-controls') ? document.querySelector('.page-controls') : null;

        // Get Image
        let configuratorImage = document.querySelector('.configurator__section__fields__subsection--image') ? document.querySelector('.configurator__section__fields__subsection--image').closest('.configurator') : null;

        // Get Side
        let configuratorSide = document.querySelector('.configurator__selector__side') ? document.querySelector('.configurator__selector__side').closest('.configurator') : null;
        // Add new class for future use
        if (configuratorSide) {
            configuratorSide.classList.add('configuratorSide');
        }

        // Get questions
        let configuratorQuestions = configurators[2];

        // New locations
        let leftHandSide = document.querySelector('#configurator-revamp-container .configurator_summary');
        let rightHandSide = document.querySelector('#configurator-revamp-container .configurator_controllers');

        // Add sections to configurator
        configuratorSections.forEach(configuratorSection => {
            configuratorQuestions.appendChild(configuratorSection);
        });

        // Add new class for future use
        // Append Image
        if (configuratorImage) {
            configuratorImage.classList.add('configuratorImage');
            leftHandSide.prepend(configuratorImage);
        } else {
            // Sometimes image isnt moved on time, i assume a delay in the asset rendering
            // Lets detect a change and then move it
            let observer = new MutationObserver(function (mutations) {
                if (document.querySelector('.configurator__section__fields__subsection--image')) {
                    // Get Image
                    configuratorImage = document.querySelector('.configurator__section__fields__subsection--image') ? document.querySelector('.configurator__section__fields__subsection--image').closest('.configurator') : null;
                    // Add new class for future use
                    // Append Image
                    if (configuratorImage) {
                        configuratorImage.classList.add('configuratorImage');
                        leftHandSide.prepend(configuratorImage);
                    }
                    observer.disconnect();
                }
            });
            observer.observe(document.querySelector('body'), { attributes: false, childList: true, characterData: false, subtree: true });
        }

        // Append CTA Controller
        if (ctaController) {
            leftHandSide.append(ctaController);
        }
        // Append Page Controls
        if (pageControls) {
            leftHandSide.append(pageControls);
        }
        // Append Product Details
        if (productDetails) {
            rightHandSide.appendChild(productDetails);
        }
        // Append Side
        if (configuratorSide) {
            rightHandSide.appendChild(configuratorSide);
        }
        // Append others
        if (configuratorQuestions) {
            rightHandSide.appendChild(configuratorQuestions);
        }


        // Earmolds
        // Page has a class of .configurator-earmold added

        let observerEarmold = new MutationObserver(function (mutations) {
            let getEarmoldsMaterial = document.querySelector('.configurator__section__fields__subsection--shell-types');
            if (getEarmoldsMaterial) {
                observerEarmold.disconnect();
                // Create new element to house these as CSS needs to be different
                let earmoldExtrasDiv = document.createElement('div');
                earmoldExtrasDiv.classList.add('earmold-extras');

                // Get Families
                let configuratorFamily = document.querySelector('.configurator__section__fields__subsection--families') ? document.querySelector('.configurator__section__fields__subsection--families') : null;
                // Append Families
                if (configuratorFamily) {
                    configuratorFamily.classList.add('configuratorFamily');
                    // Turned off, not needed for now
                    //earmoldExtrasDiv.appendChild(configuratorFamily);
                }

                // Get Material
                let configuratorMaterial = document.querySelector('.configurator__section__fields__subsection--shell-types') ? document.querySelector('.configurator__section__fields__subsection--shell-types') : null;
                // Append Material
                if (configuratorMaterial) {
                    // Disable radios that are not available
                    const radioInputs = configuratorMaterial.querySelectorAll('input[type="radio"]');
                    radioInputs.forEach(radioInput => {
                        if (!radioInput.hasAttribute('data-available')) {
                            radioInput.setAttribute('disabled', true);
                        }
                    });

                    configuratorMaterial.classList.add('configuratorMaterial');
                    earmoldExtrasDiv.appendChild(configuratorMaterial);
                }

                // Append
                document.querySelector('.configurator_controllers').insertBefore(earmoldExtrasDiv, document.querySelector('.configuratorSide'));
            }
        });
        if (document.querySelector('.configurator-earmold')) {
            observerEarmold.observe(document.querySelector('body'), { attributes: false, childList: true, characterData: false, subtree: true });
        }

        if (this.debug.debugOn) {
            console.log('%c configurators Called', this.debug.consoleChildTrue);
            console.log(configurators);
        }

    }

    #audiogram() {
        if (this.debug.debugOn) {
            console.log('%c audiogram Called', this.debug.consoleParentTrue);
        }
        // check if audiogram section exists
        // If it does exist we need to move the buttons around as we cant do this correctly with pure css
        if (document.querySelector('#cssConfigureAudiogram')) {
            let observer = new MutationObserver(function (mutations) {
                if (document.contains(document.getElementById('graphRightEar'))) {
                    observer.disconnect();
                    let clearButton = document.querySelector('[name*="LeftClearButton"]');
                    let graph = document.getElementById('graphRightEar');
                    graph.appendChild(clearButton);
                }
                if (document.contains(document.getElementById('graphLeftEar'))) {
                    observer.disconnect();
                    let clearButton = document.querySelector('[name*="RightClearButton"]');
                    let graph = document.getElementById('graphLeftEar');
                    graph.appendChild(clearButton);
                }
            });
            observer.observe(document.querySelector('#cssConfigureAudiogram'), { attributes: false, childList: true, characterData: false, subtree: true });
        }
    }

    #wireless() {
        if (this.debug.debugOn) {
            console.log('%c wireless Called', this.debug.consoleParentTrue);
        }
        let wireless = document.querySelector('[id*="_AccessoriesContainer"]') ? document.querySelector('[id*="_AccessoriesContainer"]') : null;
        let carouselWrapper = document.querySelector('#configurator-revamp-container .carouselWrapper');
        // check if wireless section exists
        // If it does we need to take it out of right hand side and move underneath
        if (wireless) {
            carouselWrapper.appendChild(wireless);
            carouselWrapper.classList.remove('is-hidden');
        }
    }

    //get showHCPMarkup() {
    //    if (this.debug.debugOn) {
    //        console.log('%c showHCPMarkup Called', this.debug.consoleParentTrue);
    //    }
    //    return this.dataset.show?.toLowerCase() === 'true' || this.dataset.show === '1';
    //}

    #launchModal() {
        if (this.debug.debugOn) {
            console.log('%c launchModal Called', this.debug.consoleParentTrue);
        }
        let button = document.querySelector('.add_to_cart-hcp');
        button.addEventListener('click', function (e) {
            e.preventDefault();
            document.querySelector('.configurator_modal').showModal();
        });
    }

    #colorPicker() {
        if (this.debug.debugOn) {
            console.log('%c colorPicker Called', this.debug.consoleParentTrue);
        }
        let colorPickers = document.querySelectorAll('[id*="ColourPickerContainer"]');
        let colorPickerWrapper = '';
        colorPickers.forEach((colorPicker, i) => {
            colorPickerWrapper = "<color-dropdown data-use-dropdown='true'>" + colorPicker.innerHTML + "</color-dropdown>";
            colorPickers[i].innerHTML = colorPickerWrapper;
        });
    }

    #watchDocument() {
        if (this.debug.debugOn) {
            console.log('%c watchDocument() Called', this.debug.consoleParentTrue);
        }
        document.addEventListener('change', (e) => {
            if (this.debug.debugOn) {
                console.log('%c Document changed', this.debug.consoleChildTrue);
                console.log(e);
            }
            let colors = document.querySelectorAll('color-dropdown .configurator__color__input:checked');
            colors.forEach(color => {
                if (this.debug.debugOn) {
                    console.log('%c Selected colors: ' + color.value, this.debug.consoleChildTrue);
                }
            });
        });
    }

    #copyColorsToOtherSide() {
        if (this.debug.debugOn) {
            console.log('%c copyColorsToOtherSide() Called', this.debug.consoleParentTrue);
        }
        let colorPickerSidecheck = document.querySelector('color-dropdown').closest('.configurator__section').querySelector('.configurator__section__fields__copy-values .configurator__label') ? document.querySelector('color-dropdown').closest('.configurator__section').querySelector('.configurator__section__fields__copy-values .configurator__label') : null;

        if (colorPickerSidecheck) {
            colorPickerSidecheck.addEventListener('click', () => {
                // Function to copy colors
                function copyColor() {
                    // Get color pickers for side1 and side2
                    let colorPickersSide1 = document.querySelectorAll('.configurator__section__fields--right color-dropdown');
                    let colorPickersSide2 = document.querySelectorAll('.configurator__section__fields--left color-dropdown');

                    // Loop through color pickers
                    // Grab value of color picked and index of color picker updated
                    // Find other side color picker with same index as color picker just changed
                    // Loop through all the color options
                    // click the color equal to the one we just picked
                    // So they both match in the ui
                    colorPickersSide1.forEach((colorPickerSide1, i) => {
                        // Currently selected color we need to match on other side
                        let colorPicked = colorPickerSide1.querySelector('.form-select__placeholder .form-select__list-label').innerText.toUpperCase().replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                        let colorsToMatch = colorPickersSide2[i] ? colorPickersSide2[i].querySelectorAll('.form-select__list .form-select__list-label') : null;
                        if (colorsToMatch) {
                            colorsToMatch.forEach(colorToMatch => {
                                let colorToMatchValue = colorToMatch.innerText.toUpperCase().replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                                if (colorToMatchValue === colorPicked) {
                                    colorToMatch.closest('div').click();
                                }
                            });
                        }
                    });
                }

                // Only copy colors if
                if (colorPickerSidecheck.parentNode.querySelector('input').checked) {
                    copyColor();
                }
            });
        }

    }

    #findDisabled() {
        if (this.debug.debugOn) {
            console.log('%c findDisabled() Called', this.debug.consoleParentTrue);
        }

        let hiddenColors = document.querySelectorAll('.configurator__section__colors');
        let disabledClass = '.disabled-div';

        // Reset disabled state for UI elements
        let uiOptions = document.querySelectorAll('color-dropdown .form-select__list .form-select__list-label');
        uiOptions.forEach(uiOption => {
            //console.log(uiOption);
            uiOption.parentNode.parentNode.classList.remove('disabled-div');
        });

        // Loop through all color pickers
        // Find all colors with disabledClass
        // Loop through hidden select options and visible UI options to compare value with color with disabledClass
        // Disable / add class to that item
        hiddenColors.forEach(hiddenColor => {
            let disabledDivs = hiddenColor.querySelectorAll(disabledClass);

            let disabledColors = [];
            disabledDivs.forEach(disabledDiv => {
                disabledColors.push(disabledDiv.querySelector('label').innerText.toUpperCase().replace(/[\n\r]+|[\s]{2,}/g, ' ').trim());
            });
            //console.log(disabledColors);

            // Disable color in Select
            let selectOptions = hiddenColor.parentNode.querySelectorAll('select option');
            selectOptions.forEach(selectOption => {
                let selectOptionText = selectOption.getAttribute('data-label').toUpperCase().replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                if (disabledColors.includes(selectOptionText)) {
                    //console.log('Disable: ' + selectOptionText + ' in select menu');
                    selectOption.disabled = true;
                }
            });

            // Disable color in UI
            let uiOptions = hiddenColor.parentNode.querySelectorAll('.form-select__list .form-select__list-label');
            uiOptions.forEach(uiOption => {
                let uiOptionText = uiOption.innerText.toUpperCase().replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                if (disabledColors.includes(uiOptionText)) {
                    //console.log('Disable: ' + uiOptionText + ' in ui');
                    uiOption.parentNode.parentNode.classList.add('disabled-div');
                }
            });
        });
    }

    #accessorySwiper() {
        if (this.debug.debugOn) {
            console.log('%c accessorySwiper() Called', this.debug.consoleParentTrue);
        }
        let accessories = document.querySelectorAll('[id*="_AccessoriesContainer"]');

        let accessoriesWrapper = '';
        accessories.forEach((accessory, i) => {
            accessoriesWrapper = "<accessories-carousel class='loading version-generic'>" + accessory.innerHTML + "</accessories-carousel>";
            accessory.innerHTML = accessoriesWrapper;
        });
        let originalInputs = document.querySelectorAll('.configurator__accessories .hiddenController .number-input__field');
        originalInputs.forEach((input, i) => {
            input.setAttribute('id', input.name);
        });
        let originalSelects = document.querySelectorAll('.configurator__accessories .hiddenController .form-select select');
        originalSelects.forEach((select, i) => {
            select.setAttribute('id', select.name);
        });
        // Chargers use checkboxes not quantity
        let checkboxes = document.querySelectorAll('.configurator__accessories .product-item__checkbox label');
        checkboxes.forEach((checkbox, i) => {
            checkbox.addEventListener('click', (e) => {
                let checkboxInput = checkbox.closest('.product-item__checkbox').querySelector('input');
                if (checkboxInput.checked == false) {
                    checkboxInput.checked = true;
                } else {
                    if (checkboxInput.checked == true) {
                        checkboxInput.checked = false;
                    }
                }
            });
        });
    }

    #chargers() {
        if (this.debug.debugOn) {
            console.log('%c chargers() Called', this.debug.consoleParentTrue);
        }

        // Get charger container div
        const chargerContainer = document.querySelector('[id*="_ChargerContainer"]') ? document.querySelector('[id*="_ChargerContainer"]') : null;

        if (chargerContainer) {
            // Attach an event listener to it
            chargerContainer.addEventListener('click', (event) => {
                // Only handle clicks on checkboxes
                if (event.target.type === 'checkbox') {
                    handleCheckboxClick(event);
                }
            });
        }

        function handleCheckboxClick(event) {
            // Get the parent div
            const parentDiv = event.target.closest('[id*="_ChargerContainer"]');

            // Get all checkboxes within the parent div
            const checkboxes = parentDiv.querySelectorAll('input.configurator__accessory-checkbox');

            // Uncheck all checkboxes except the one that was just clicked
            checkboxes.forEach((checkbox) => {
                if (checkbox !== event.target) {
                    checkbox.checked = false;
                }
            });
        }
    }

    #showOldErrors() {
        if (this.debug.debugOn) {
            console.log('%c showOldErrors Called', this.debug.consoleParentTrue);
        }
        // As we are now hiding the old container we need to check if there are any alerts so they can be reshown.
        let errorWrapper = document.querySelector('#configurator-container .alert-danger');
        if (errorWrapper) {
            if (this.debug.debugOn) {
                console.log('%c Old errors found', this.debug.consoleChildTrue);
            }
            errorWrapper.closest('.configurator_contents').style.display = 'block';
            errorWrapper.closest('#configurator-container').style.display = 'block';
        } else {
            if (this.debug.debugOn) {
                console.log('%c No old errors found', this.debug.consoleChildTrue);
            }
        }
    }

    #translateSideLabels() {
        if (this.debug.debugOn) {
            console.log('%c translateSideLabels Called', this.debug.consoleParentTrue);
        }
        let leftSideString = document.querySelector('.configurator__selector__side.configurator__selector__side--left label').innerHTML;
        let rightSideString = document.querySelector('.configurator__selector__side.configurator__selector__side--right label').innerHTML;

        let areasToInjectTranslatedStrings = document.querySelectorAll('.configurator__section__fields__header');

        areasToInjectTranslatedStrings.forEach((area) => {
            if (area.parentElement.classList.contains('configurator__section__fields--right')) {
                area.innerHTML = rightSideString;
            } else if (area.parentElement.classList.contains('configurator__section__fields--left')) {
                area.innerHTML = leftSideString;
            }
        });

        // check if audiogram section exists
        if (document.querySelector('#cssConfigureAudiogram')) {
            let observer = new MutationObserver(function (mutations) {
                if (document.contains(document.getElementById('graphRightEar'))) {
                    observer.disconnect();
                    let audiogramRight = document.getElementById('graphRightEar');
                    let spanSide = '';
                    spanSide = document.createElement('span');
                    spanSide.classList.add('configurator__section__fields__header');
                    spanSide.innerHTML = rightSideString;
                    audiogramRight.prepend(spanSide);
                }
                if (document.contains(document.getElementById('graphLeftEar'))) {
                    observer.disconnect();
                    let audiogramLeft = document.getElementById('graphLeftEar');
                    let spanSide = '';
                    spanSide = document.createElement('span');
                    spanSide.classList.add('configurator__section__fields__header');
                    spanSide.innerHTML = leftSideString;
                    audiogramLeft.prepend(spanSide);
                }
            });
            observer.observe(document.querySelector('#cssConfigureAudiogram'), { attributes: false, childList: true, characterData: false, subtree: true });
        }
    }

    #textAreaMaxLength() {
        if (this.debug.debugOn) {
            console.log('%c textAreaMaxLength Called', this.debug.consoleParentTrue);
        }
        let textAreas = document.querySelectorAll('[data-groupcode="Special instructions"]');
        let maxChars = 255;

        if (textAreas) {
            textAreas.forEach(textArea => {
                textArea.setAttribute('maxlength', maxChars);

                let charBlock = document.createElement('p')
                charBlock.classList.add('char_count', 'configurator__section__help');
                textArea.parentElement.appendChild(charBlock);

                let characterCounter = textArea.parentElement.querySelector('.char_count');
                const maxNumOfChars = maxChars;

                const countCharacters = () => {
                    let numOfEnteredChars = textArea.value.length;
                    let counter = maxNumOfChars - numOfEnteredChars;
                    if (counter === 0) {
                        charBlock.style.color = '#e03e52';
                    } else {
                        charBlock.style.color = '';
                    }
                    characterCounter.textContent = counter + '/' + maxChars;
                };

                textArea.addEventListener('input', countCharacters);

            });
        }

    }

    #matchColorsOnUI() {
        let debug = this.debug;
        if (debug.debugOn) {
            console.log('%c matchColorsOnUI Called', debug.consoleParentTrue);
        }

        // For each color picker container
        // find the child which has checked=checked
        // set that child to checked = true
        // get the label of that and trim it
        // wait for the color dropdown to appear
        // get list of colors and compare with child thats been checked and click it
        // this will make the ui match the hidden checked field

        let colorPickers = document.querySelectorAll('[id*="ColourPickerContainer"]') ? document.querySelectorAll('[id*="ColourPickerContainer"]') : null;
        if (colorPickers) {
            colorPickers.forEach(colorPicker => {
                // Get color for user checked item
                let userColor = colorPicker.querySelector('input[checked="checked"]') ? colorPicker.querySelector('input[checked="checked"]') : null;
                if (userColor) {
                    if (debug.debugOn) {
                        console.log('%c Color to match: ' + userColor.value, debug.consoleChildTrue);
                    }
                    // Set checked status correctly
                    userColor.checked = true;
                    // Get the now correctly checked color
                    let userColorChecked = colorPicker.querySelector('input:checked');
                    // Make label text more usable for comparison
                    let userColorCheckedLabel = userColorChecked.parentElement.querySelector('.configurator__color__label').innerText.toUpperCase().replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                    // Wait for color dropdown to appear
                    let observer = new MutationObserver(function (mutations) {
                        if (document.querySelector('color-dropdown')) {
                            observer.disconnect();
                            if (debug.debugOn) {
                                console.log('%c Color Dropdown found ', debug.consoleChildTrue);
                            }
                            let colorsToMatch = colorPicker.querySelectorAll('.form-select__list-label');
                            if (colorsToMatch) {
                                colorsToMatch.forEach(colorToMatch => {
                                    let colorToMatchValue = colorToMatch.innerText.toUpperCase().replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
                                    if (colorToMatchValue === userColorCheckedLabel) {
                                        colorToMatch.closest('div').click();
                                        if (debug.debugOn) {
                                            console.log('%c Color Dropdown should match ', debug.consoleChildTrue);
                                        }
                                    }
                                });
                            }
                        }
                    });
                    observer.observe(colorPicker, { attributes: false, childList: true, characterData: false, subtree: true });
                }
            });
        }
    }
   
    #clickFirstNonDisabledColor() {
        let debug = this.debug;
        if (debug.debugOn) {
            console.log('%c clickFirstNonDisabledColor() Called 777', debug.consoleParentTrue);
        }

        // Get the color dropdowns if they exist
        let colorDropdowns = document.querySelectorAll('color-dropdown') ? document.querySelectorAll('color-dropdown') : null;

        // Convert to an array so we can filter if the color dropdowns exist
        let arrayColorDropdowns = colorDropdowns ? Array.from(colorDropdowns) : null;

        // Filter the array to exclude elements with a parent having our specific class (left side vs right side visibile or both) if the array exists
        let filterVisibleColorDropdowns = arrayColorDropdowns ? arrayColorDropdowns.filter(div => !div.closest('.configurator__section__fields').classList.contains('configurator__section__fields--disabled')) : null;

        // Filter the array to exclude elements without any out of stock colors 
        let filterOutOfStockColorColorDropdowns = filterVisibleColorDropdowns ? filterVisibleColorDropdowns.filter(div => div.querySelector('.form-select__list-item.disabled-div')) : null;

        if (filterOutOfStockColorColorDropdowns) {
            if (debug.debugOn) {
                console.log('%c Color Dropdown found with out of stock colors ', debug.consoleChildTrue);
            }
            filterOutOfStockColorColorDropdowns.forEach(colorDropdown => {
                let selectedColor = colorDropdown.querySelector('.configurator__section__colors input:checked');
                // If the selected color is null then that means the user has selected a now disabled color so we need to reset the color picker to the first available color
                if (selectedColor == null){
                    // Get all li elements within the form-select__list
                    let liElements = colorDropdown.querySelectorAll('.form-select__list-item');
                    // Loop through the li elements
                    for (let liElement of liElements) {
                        // Check if the li element does not have the class 'disabled-div'
                        if (!liElement.classList.contains('disabled-div')) {
                            liElement.querySelector('div').click();
                            if (debug.debugOn) {
                                console.log('%c Clicked: ' + liElement.querySelector('div span').textContent.trim(), debug.consoleChildTrue);
                            }
                            // break out of the loop after clicking the first available color
                            break;
                        }
                    }
                }
            });
        }
    }

    connectedCallback() {
        if (this.debug.debugOn) {
            console.log('%c connectedCallback() ITE Config Called', this.debug.consoleParent);
        }

        let $this = this;

        // Run our code if not viewing a warranty
        let warrantyCheck = document.querySelectorAll('[data-is-warranty="True"]');
        if (warrantyCheck.length == 0) {
            if (this.debug.debugOn) {
                console.log('%c ITE Product', this.debug.consoleParent);
            }
            this.#showConfigurator();
            this.#getQuestions();
            // Bespoke JS and CSS help for Audiogram
            this.#audiogram();
            // Bespoke JS and CSS help for Wireless
            this.#wireless();
            // Bespoke JS and CSS help for Chargers
            this.#chargers();
            //this.#launchModal();
            // Changes color picker from radios to dropdown, will repeat for each color picker
            this.#colorPicker();
            if (document.querySelector('[id*="ColourPickerContainer"]')) {
                // Once color pickers are converted we need to be able to copy colors in the new ui
                this.#copyColorsToOtherSide();
                // Once color pickers are converted we need to find disabled colors from original radios and pass to new ui
                // These disabled colors are actually dynamic so we need to continue watching them for changes, some products 
                // have specific colors for specific version so we need to show the disabled options when updated
                let targetsToObserve = document.querySelectorAll('[id*="_ColorPanel"]');
                targetsToObserve.forEach(targetToObserve => {
                    let observer = new MutationObserver(function (mutations) {
                        if (targetToObserve.querySelector('.configurator__section__color')) {
                            $this.#findDisabled();
                            $this.#clickFirstNonDisabledColor();
                        }
                    });
                    observer.observe(targetToObserve, { attributes: true, attributeFilter: ['style', 'class'], childList: true, characterData: false, subtree: true });
                });
            }
            this.#accessorySwiper();
            this.#showOldErrors();
            this.#translateSideLabels();
            this.#matchColorsOnUI();
            this.#textAreaMaxLength();

            // Build Summary
            buildSummary();

            // Validation
            validation();

            // Help for some debugging
            if (this.debug.debugOn) {
                this.#watchDocument();
            }
        } else {
            if (this.debug.debugOn) {
                console.log('%c Warranty', this.debug.consoleParent);
            }
        }

    }
}